export default __webpack_public_path__ + "49fd9f73509d9bf6036a3ceef11dc4ea.png";